/* unsafe-eval */

/**
 * jQuery
 */
import $ from "cash-dom";

$(document).ready(function () {
    $("html").addClass("document-ready");
});

$(window).on("load", function () {
    $("html").addClass("window-loaded");
});

var log = typeof debug !== "undefined";
if (log) console.info("%cscript.site.js initialized", "color: green;");

import escKey from "imports/event_esc-key";
import resize from "imports/event_resize";
import categoryFilter from "imports/function_category-filter";
import cover from "imports/function_cover";
import contain from "imports/function_contain";
import hero from "imports/function_hero";
import iframeStyles from "imports/function_iframe-styles";
import lazyLoad from "imports/function_lazy-load";
import matomoeOptOut from "imports/function_matomo-opt-out";
import menuButton from "imports/function_menu-button";
